import PropTypes from "prop-types";
import ALShopifyImage from "@components/al_components/ALShopifyImage";
import PriceContainer from "@components/PriceContainer";
import useDeviceDetect from "@hooks/useDeviceDetect";
import { ComponentType } from "@constants/ComponentType";

function LuxeGiftSideCart({ giftLineItem }) {
  const { isMobile } = useDeviceDetect();

  const image = giftLineItem?.variant?.image;
  const title = giftLineItem?.variant?.product?.title.split(" - ")[1];

  if (!giftLineItem || !giftLineItem.variant || !giftLineItem.variant.product) {
    return null;
  }

  return (
    <div className="flex p-[15px] bg-light-grey desktop:p-[20px]">
      <div className="relative w-[18.67%] desktop:min-w-[18.98%]">
        <div className="block overflow-hidden">
          <ALShopifyImage
            data-testid="luxe-gift-image"
            className="aspect-[0.8] scale-[1.4]"
            url={image?.url}
            alt={image?.altText}
            width={isMobile ? 140 : 180}
          />
        </div>
      </div>
      <div className="flex flex-1 flex-col justify-between ml-[15px]">
        <div className="w-full flex justify-between items-start">
          <div>
            <div className="typo-body-bold mb-[3px]">{title}</div>
            <div className="typo-micro-bold-caps px-[7px] py-[3px] rounded-[4px] uppercase bg-primary text-white">
              members-only gift unlocked
            </div>
          </div>
          <PriceContainer
            selectedVariant={giftLineItem?.variant}
            productId={giftLineItem?.variant?.product?.id}
            componentType={ComponentType.SIDE_CART}
            isFree
          />
        </div>
      </div>
    </div>
  );
}

LuxeGiftSideCart.propTypes = {
  giftLineItem: PropTypes.shape({
    variant: PropTypes.shape({
      image: PropTypes.shape({
        url: PropTypes.string,
        altText: PropTypes.string,
      }),
      product: PropTypes.shape({
        title: PropTypes.string,
        id: PropTypes.string,
      }),
    }),
  }),
};

export default LuxeGiftSideCart;
